function scrollFixed(self, bot){
    window.addEventListener("scroll", function(event) {
        var scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
        // console.log(scrollTop); 
        var docSelf = document.getElementById(self);
        var docBot = document.getElementById(bot);
        if(docSelf!=null && docBot!=null){
            if(scrollTop >= docBot.offsetTop - docSelf.offsetHeight){
                // alert('dad');
                docSelf.classList.add('isFixed');
                docBot.style.marginTop = docSelf.offsetHeight;
            }else{
                docSelf.classList.remove('isFixed');
                docBot.style.marginTop = 0;
            }
        }
        // if(document.scrollHeight == document.documentElement.clientHeight + scrollTop ) {
        //     alert("到底部啦");
        // } 
    });
}

export default scrollFixed;


// WEBPACK FOOTER //
// ./src/common/utils/scrollfixed.js